import React from "react";
import { useI18n } from "../../i18n/useI18n";

type Logo = {
  src: string;
  alt: string;
};

const prettifyAlt = (filename: string) =>
  filename
    .replace(/\.[a-z0-9]+$/i, "")
    .replace(/[-_]+/g, " ")
    .replace(/\blogo\b/i, "")
    .trim()
    .replace(/\s+/g, " ");

const loadLogos = (): Logo[] => {
  const modules = import.meta.glob(
    "../../assets/logo/*.{png,jpg,jpeg,svg,webp}",
    {
      eager: true,
      import: "default",
    },
  ) as Record<string, string>;

  return Object.entries(modules)
    .map(([path, src]) => {
      const filename = path.split("/").pop() ?? path;
      return { src, alt: prettifyAlt(filename) || "Company logo" };
    })
    .sort((a, b) => a.alt.localeCompare(b.alt));
};

const EricaLogos: React.FC = () => {
  const { lang } = useI18n();
  const logos = React.useMemo(() => loadLogos(), []);

  if (logos.length === 0) return null;

  return (
    <section id="logos" className="bg-white py-16 sm:py-20">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="mx-auto max-w-3xl text-center">
          <h2 className="text-3xl font-semibold tracking-tight text-slate-900 sm:text-4xl">
            {lang === "id"
              ? "Rekayasa (RAD) telah dipercaya oleh"
              : "Rekayasa (RAD) has been trusted by"}
          </h2>
          <p className="mt-4 text-base text-slate-600">
            {lang === "id"
              ? "Beberapa logo berikut digunakan untuk menunjukkan pengalaman implementasi dan kolaborasi."
              : "A few logos to reflect our implementation experience and collaborations."}
          </p>
        </div>

        <div className="mt-12 flex flex-wrap items-center justify-center gap-x-14 gap-y-10 sm:gap-x-16">
          {logos.map((logo) => (
            <img
              key={logo.src}
              src={logo.src}
              alt={logo.alt}
              loading="lazy"
              className="h-12 w-auto opacity-90 transition hover:opacity-100 sm:h-14 lg:h-16"
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default EricaLogos;
